//CertificationTestOthers.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import '../styles/MCQPractice.css';
import { useSelector } from 'react-redux';
import Loader from '../../../components/utils/Loader';
import Tooltip from '../../../components/utils/Tooltip';

const CertificationTestOthers = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [userId, setUserId] = useState(authState.user._id);

    const [selectedSetId, setSelectedSetId] = useState('');
    const [setMasterList, setSetMasterList] = useState([]);
    const [examSetList, setExamSetList] = useState([]);
    const [selectedExamSetId, setSelectedExamSetId] = useState('');

    const [examMaster, setExamMaster] = useState([]);
    const [isRepeated, setIsRepeated] = useState(0);

    const fetchSetMasters = useCallback(() => {
        const config = {
            url: "/setmaster/sets",
            method: "post",
            headers: { Authorization: authState.token},
            data: {
                isT5w: 0, 
                setType: "Certification",
                setQuestionType: "MCQ" 
            }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response:", response);
                if (response && Array.isArray(response.setmasterlist)) {
                    setSetMasterList(response.setmasterlist);
                } else {
                    console.error("Invalid response format: Set master list not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching set masters:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchSetMasters();
    }, [authState.isLoggedIn, fetchSetMasters]);

    //MyExamSetList
    const fetchExamSetList = useCallback(() => {
        const config = {
            url: "/myexamsets/mysets",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userId: userId, isT5w: 0, setQuestionType: "MCQ" }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Exam Set List Response:", response);
                if (response && Array.isArray(response.examsetlist)) {
                    setExamSetList(response.examsetlist);
                } else {
                    console.error("Invalid response format: Exam set list not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching exam list:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        fetchExamSetList();
    }, [fetchExamSetList]);

    const sortedSetMasterList = [...setMasterList].sort((a, b) => a.setDisplaySn - b.setDisplaySn);
    const sortedExamSetList = [...examSetList].sort((a, b) => new Date(b.dateExam) - new Date(a.dateExam));

    useEffect(() => {
        let newExamMaster = [];
        sortedExamSetList.forEach(examSet => {
            const matchingSetMaster = sortedSetMasterList.find(setMaster => setMaster._id === examSet.setId);
            if (matchingSetMaster) {
                newExamMaster.push(matchingSetMaster);
            }
        });
        setExamMaster(newExamMaster);
    }, [sortedSetMasterList, sortedExamSetList]);


    const handleSetMasterView = (setId) => {
        setSelectedSetId(prevId => (prevId === setId ? null : setId));
    };

    const handleExamSetView = (setId) => {
        setSelectedExamSetId(prevId => (prevId === setId ? null : setId));
    };

    const handleCertificateView = (setId) => {
        navigate('/my-certificates-others');
    };

    
    const handleExamClick = (setId, setTitle, seriesId, seriesTitle, examId, examTitle, examType, timeLimitInMin, isRepeated) => {
        navigate('/exam', { state: { setId: setId, isT5w: 0, setTitle: setTitle, seriesId: seriesId, seriesTitle: seriesTitle, examId: examId, examTitle: examTitle, examType: examType, timeLimitInMin: timeLimitInMin, isRepeatExam: isRepeated } });
    };

    function convertTimeLimit(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const formattedTimeLimit = `${hours}:${remainingMinutes} (Hr:Min)`;
        return formattedTimeLimit;
    }

    function convertTimeTaken(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const remainingMinutes = Math.floor((milliseconds % 3600000) / 60000);
        const remainingSeconds = Math.floor((milliseconds % 60000) / 1000);
        const remainingMilliseconds = milliseconds % 1000;
        const formattedTime = `${hours}:${remainingMinutes
            .toString()
            .padStart(2, "0")}:${remainingSeconds
                .toString()
                .padStart(2, "0")}.${remainingMilliseconds
                    .toString()
                    .padStart(3, "0")} (Hr:Min:Sec)`;
        return formattedTime;
    }

    return (
        <div className="min-h-screen bg-black py-2 [&_p]:text-white">
            <div className='border-b border-blue-400 mb-2'>
                <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
                    📖 Certification Assessment / Exam
                </h2>
            </div>
            <div className="min-h-[85vh] py-2 bg-black text-white mb-2">
                {loading ? (
                    <Loader />
                ) : (
                    <div className='mx-4'>
                        <div className="flex flex-col">
                            <div className='flex flex-col'>
                                <div>
                                    {setMasterList && setMasterList.length === 0 ? (
                                        <div className='h-[300px] flex items-center justify-center text-yellow-300'>
                                            No records found!
                                        </div>
                                    ) : (
                                        sortedSetMasterList.map((setMaster, index) => (
                                            <div key={setMaster._id} className='bg-black border border-gray-300 my-4 p-4 text-white rounded-md shadow-md'>
                                                <div className='flex'>
                                                    <span className={examMaster.some(exam => exam._id === setMaster._id) ? 'font-medium text-yellow-500' : 'font-medium'}>
                                                        {index + 1}. 
                                                    </span>
                                                    <span className={setMaster?.setTitle?.includes("Mock") ? "text-gray-200 text-sm lg:text-m" : "text-white text-sm lg:text-m"}>
                                                        {setMaster.setTitle}
                                                    </span>
                                                    <Tooltip text={"View details"} position={"top"}>
                                                        <span className='ml-auto mr-2 text-gray-100 cursor-pointer' onClick={() => handleSetMasterView(setMaster._id)}>
                                                            <i className="fa-solid fa-eye"></i>
                                                        </span>
                                                    </Tooltip>
                                                    <button
                                                        className={`ml-4 px-2 py-1 h-8 text-xs lg:text-m w-48 lg:w-48 text-white rounded ${examMaster.find(item => item._id === setMaster._id) ? 'bg-blue-500' : 'bg-green-500'}`}
                                                        onClick={() => handleExamClick(setMaster._id, setMaster.setTitle, setMaster.seriesId, setMaster.seriesTitle, setMaster.examId, setMaster.examTitle, setMaster.examType, setMaster.timeLimitInMin, examMaster.find(item => item._id === setMaster._id) ? 1 : 0)}
                                                    >
                                                        {examMaster.find(item => item._id === setMaster._id) ? "Repeat Exam" : "Start Exam"}
                                                    </button>
                                                </div>
                                                <div className='whitespace-pre-line break-words text-sm lg:text-m text-blue-700'>{setMaster.setDesc}</div>
                                                {selectedSetId === setMaster._id && (
                                                    <div className='bg-black border border-blue-600 p-2 text-white'>
                                                        <h2 className='text-yellow-200'><strong>{setMaster.setTitle}</strong></h2>
                                                        <p><strong>Total Questions:</strong> {setMaster.setTotalQuestions}</p>
                                                        <p><strong>Time Limit (In Minutes):</strong> {setMaster.timeLimitInMin}</p>
                                                        <p><strong>Marks for Correct Answer:</strong> {setMaster.correctAnswerPoints}</p>
                                                        <p><strong>Marks for Wrong Answer:</strong> {setMaster.WrongAnswerPoints}</p>
                                                        <p><strong>Exam Type:</strong> {setMaster.examType}</p>
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    )}
                                </div>
                                <div className='flex flex-col'>
                                    <h2 className="md:ml-0 text-white bg-green-600 rounded p-2">My Exam List</h2>
                                    <div>
                                        {examSetList && examSetList.length === 0 ? (
                                            <div className='h-[300px] flex items-center justify-center text-yellow-300'>
                                                No records found!
                                            </div>
                                        ) : (
                                            sortedExamSetList.map((examSet, index) => (
                                                <div key={examSet._id} className='bg-black border border-gray-400 my-4 p-4 text-white rounded-md shadow-md'>
                                                    <div className='flex'>
                                                        <span className='font-medium'>{index + 1}. {examSet.examTitle},  Date: {examSet.dateExam}</span>
                                                        <Tooltip text={"View details"} position={"top"}>
                                                            <span className='ml-auto mr-2 text-gray-200 cursor-pointer' onClick={() => handleExamSetView(examSet._id)}>
                                                                <i className="fa-solid fa-eye"></i>
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                    {selectedExamSetId === examSet._id && (
                                                        <div className='bg-black border border-green-500 text-white mt-4 p-4 rounded-md'>
                                                            <h2 className='text-yellow-200 text-lg md:text-xl font-bold'>{examSet.examTitle}</h2>
                                                            <p><strong>Exam Date:</strong> {new Date(examSet.dateExam).toLocaleDateString()}</p>
                                                            <p><strong>Is Repeated:</strong> {examSet.isRepeatExam === 1 ? 'Yes' : 'No'}</p>
                                                            <p><strong>Time Limit:</strong> {convertTimeLimit(examSet.timeLimit)}</p>
                                                            <p><strong>Time Taken:</strong> {convertTimeTaken(examSet.timeTaken)}</p>
                                                            <p><strong>Number of Questions:</strong> {examSet.numberOfQuestions}</p>
                                                            <p><strong>Correct Answers:</strong> {examSet.correctAnswers}</p>
                                                            <p><strong>Full Marks:</strong> {examSet.fullMarks}</p>
                                                            <p><strong>Marks Obtained:</strong> {examSet.marksObtained}</p>
                                                            <p><strong>Percentage:</strong> {examSet.percentage}%</p>
                                                            <div className="progress-container">
                                                                <div className="progress-bar">
                                                                    <div className="progress" style={{ width: `${examSet.percentage}%` }}>
                                                                        {`${examSet.percentage}%`}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
                    <div className="flex flex-wrap gap-4 text-sm">
                        <Link to="/about-us" className="hover:text-teal-300">About</Link>
                        <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                        <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                    </div>
                </div>
            </footer>  
        </div>
    );
};

export default CertificationTestOthers;
